/**
 * @file http 异常处理
 * @author svon.me@gmail.com
 */

import {i18n} from "@/locales";
import Config from "@/config";
import tool from '@/utils/tool';
import * as modal from "@/utils/modal";
import {ElNotification} from "element-plus";
import safeGet from "@fengqiaogang/safe-get";

export const E401 = async function () {
  const status = await modal.error(i18n('common.loginOutTip'), i18n('common.loginOutTitle'), {
    closeOnClickModal: false,
    center: true,
    confirmButtonText: i18n('common.reLogin')
  });
  if (status) {
    // 删除用户信息并跳转到登录页面
    tool.cookie.remove(Config.TOKEN_KEY);
    window.location.href = `${Config.LOGIN_URL}?referer=${window.location.pathname}${window.location.search}`;
  }
}

export const E404 = function () {
  ElNotification.error({
    title: i18n('common.requestError'),
    message: i18n('common.serverNotFind')
  });
}

export const E500 = function (result) {
  const mode = safeGet(Config.env, "MODE");
  // if (mode !== "development") {
  //   return void 0;
  // }

  let msg = safeGet(result, 'msg') || safeGet(result, 'message');
  if (msg) {
    if (msg.indexOf(":") > -1) {
      const word = msg.split(":")[0];
      const remark = msg.split(":")[1];
      msg = i18n(word) + ':' + remark;
    }
  }
  const message = msg || i18n('common.serverError');
  if (message) {
    ElNotification.error({
      message: i18n(message),
      title: i18n('common.requestError'),
    });
  }
}